import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, Util} from '../../../app/util';
import {
    TAction,
    TPrecifyMenu,
    TProdutoView,
    TRuleValue
} from "../../../app/enum";
import {WebstorService} from "../../../providers/webstor-service";
import {BarcodeScanner} from "@ionic-native/barcode-scanner";
import {MessageService} from "../../../providers/message-service";


@Component({
    selector: 'page-produto-view',
    templateUrl: 'produto-view.html',
    providers: [WebstorService]
})
export class ProdutoViewPage {

    TProdutoView: any = TProdutoView;
    TPrecifyMenu: any = TPrecifyMenu;

    config: any;

    clusters: any;
    indexes: any;
    indexMR: number = -1;

    copycopy: any;
    rootspot: any;
    themedep: any;

    etapa: number;
    _count: number = 5;

    produtoView: TProdutoView;
    precifyMenu: TPrecifyMenu;

    qtdeConsumo: number;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public webstorService: WebstorService, public barcodeScanner: BarcodeScanner,
                public viewCtrl: ViewController, public messageService: MessageService,
                public util: Util) {


        this.config = CONFIG;

        this.etapa = this.navParams.get('etapa');

        this.clusters = this.navParams.get('clusters');
        this.indexes = this.navParams.get('indexes');

        this.rootspot = this.navParams.get('rootspot');
        this.themedep = this.navParams.get('themedep');

        this.produtoView = this.navParams.get('produtoView');
        this.precifyMenu = this.navParams.get('precifyMenu');


        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Produto View', '/produto-view');

        this.produtoLoad();

    }

    getTitle() {

        if (this.etapa == 0) return this.procuraLine('BL').Branded.BrandedNome;

    }

    produtoLoad() {

        //Iniciou, faz uma copia para movimentação em tela!
        this.blendedCopy('copy', null);

        if (this.produtoView == TProdutoView.pdDetalhe) {

            let produto = this.procuraLine('BL', 'PK', 'PD');
            this.barcodeScanner.encode(this.barcodeScanner.Encode.TEXT_TYPE, produto.ProdutoGtin).then(data => {

                produto.ProdutoGbar = data.file;
                //alert(JSON.stringify(data));

            }, (err) => {
                console.log("Error occured : " + err);
            });

        }

    }

    blendedCopy(action: 'copy' | 'save' | 'lixo', data, precify?) {

        if (data && data.Codigo) precify.PrecifyID = data.Codigo;
        if (data && data.Result) this.util.alertResult(data);
console.log(precify, this.indexes, this.clusters);
        let blended = this.clusters[this.indexes.indexCA].Clusters[this.indexes.indexCB].Clusters[this.indexes.indexCC].Blendeds[this.indexes.indexBL];
        let produto = this.clusters[this.indexes.indexCA].Clusters[this.indexes.indexCB].Clusters[this.indexes.indexCC].Blendeds[this.indexes.indexBL].Packages[this.indexes.indexPK].Produtos[this.indexes.indexPD];

        if (action == 'copy') this.copycopy = this.util.deepCopy(blended);
        if (action == 'save') this.util.populateObj(blended, this.copycopy);
        if (action == 'lixo') {
            this.util.populateObj(blended, this.copycopy);
            if (produto.Precifys.length == 0) this.dismiss();
        }

        if (action == 'save' || action == 'lixo') {
            let send = {action: action, clusters: this.clusters, indexes: this.indexes, precify: precify};
            console.log(send);
            this.messageService.get('produto.spot').next(send);
        }

    }

    procuraLine(BL?, PK?, BO?) {
        if (BO) return this.copycopy.Packages[this.indexes.indexPK].Produtos[this.indexes.indexPD];
        if (PK) return this.copycopy.Packages[this.indexes.indexPK];
        if (BL) return this.copycopy;
    }

    precifyLine(menu) {

        let produto = this.procuraLine('BL', 'PK', 'PD');
        let precify = produto.Precifys.find(PC => PC.PrecifyMenu == menu);
        this.indexes.indexPC = produto.Precifys.findIndex(PC => PC.PrecifyMenu == menu);

        /** OPEN **/
        let buttons: Array<any> = [];
                     buttons.push({text: 'Alterar',   handler: () => this.precifyCash(menu)});
        if (precify) buttons.push({text: 'Desativar', handler: () => this.precifyLixo(produto, precify), role: 'destructive'});
        this.util.sheetOpen(buttons, TPrecifyMenu[menu].slice(2, 99).toUpperCase());

    }

    precifyLixo(produto, precify) {

        let index = produto.Precifys.findIndex(PC => PC.PrecifyID == precify.PrecifyID);
        produto.Precifys.splice(index, 1);

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.precify(TAction.acLixo, precify.PrecifyID, produto.ProdutoID, this.rootspot.Hotspots[0].HotspotID, precify)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.blendedCopy('lixo', null),
                erro => this.blendedCopy('copy', erro));

    }

    precifySave(produto, precify) {

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.precify(TAction.acSave, precify.PrecifyID, produto.ProdutoID, this.rootspot.Hotspots[0].HotspotID, precify)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.blendedCopy('save', data, precify),
                erro => this.blendedCopy('copy', erro));

    }

    precifyEdit(produto, precify) {

        produto.Precifys.map(PC => {
            PC.PrecifyGorj = precify.PrecifyGorj;
            PC.PrecifyCoin = precify.PrecifyCoin;
            PC.PrecifyRule = precify.PrecifyRule;
        });

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.precify(TAction.acEdit, precify.PrecifyID, produto.ProdutoID, this.rootspot.Hotspots[0].HotspotID, precify)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.blendedCopy('save', null),
                erro => this.blendedCopy('copy', erro));

    }

    precifyCash(menu) {

        let produto = this.procuraLine('BL', 'PK', 'PD');
        let precify = produto.Precifys.find(PC => PC.PrecifyMenu == menu);
        let novo = !precify;

        if (novo) {
            precify = {PrecifyID: 0, PrecifyMenu: menu, PrecifyQtde: 0, PrecifyCash: 0, PrecifyGorj: false, PrecifyCoin: 0, PrecifyRule: TRuleValue.rvRulePorc};
            if (produto.Precifys.length) {
                precify.PrecifyGorj = produto.Precifys[0].PrecifyGorj;
                precify.PrecifyCoin = produto.Precifys[0].PrecifyCoin;
                precify.PrecifyRule = produto.Precifys[0].PrecifyRule;
            }
        }

        let onSave = (value, extra) => {
            precify.PrecifyCash = value;
            if (novo) {
                produto.Precifys.push(precify);
                this.indexes.indexPC = produto.Precifys.length-1;
            }
            this.precifySave(produto, precify);
        };

        this.util.pickerCash(0, 20, 5, precify.PrecifyCash, onSave);

    }

    precifyGorj() {

        let produto = this.procuraLine('BL', 'PK', 'PD');
        let precify = produto.Precifys[0];
        this.precifyEdit(produto, precify);

    }

    precifyCoin() {

        let produto = this.procuraLine('BL', 'PK', 'PD');
        let precify = produto.Precifys[0];
        let bool = precify.PrecifyCoin;

        let onSave = (value, extra) => {
            precify.PrecifyCoin = value;
            precify.PrecifyRule = extra;
            this.precifyEdit(produto, precify);
        };


        /** OPEN **/
        let buttons: Array<any> = [];
                  buttons.push({text: '%',         handler: () => this.util.pickerCent(0, 20, 1, precify.PrecifyCoin, onSave, TRuleValue.rvRulePorc)});
                  buttons.push({text: 'R$',        handler: () => this.util.pickerCash(0, 20, 5, precify.PrecifyCoin, onSave, TRuleValue.rvRuleReal)});
        if (bool) buttons.push({text: 'Desativar', handler: () => onSave(0, TRuleValue.rvRulePorc), role: 'destructive'});
        this.util.sheetOpen(buttons, 'COMISSÃO');

    }

    produtoFlug(flug: 'note' | 'coin', tagid?): string {

        let produto = this.procuraLine('BL', 'PK', 'PD');
        let precifys = produto.Precifys;

        if (flug == 'note') {

            if (this.produtoView == TProdutoView.pdPrecify) {
                let precify = precifys.find(PC => PC.PrecifyMenu == tagid);
                if (!precify) return '';

                return this.util.dinheiro(precify.PrecifyCash);
            }

            if (this.produtoView == TProdutoView.pdEstoque) {
                let estoque = produto.Estoques.find(ES => ES.DepositID == tagid);
                if (estoque) return this.util.numerico(estoque.EstoqueQtde);
            }

        }

        if (flug == 'coin') {

            let precify = precifys[0];
            if (!precify || !precify.PrecifyCoin) return '';

            return (precify.PrecifyRule ? this.util.dinheiro(precify.PrecifyCoin) : this.util.porcenta(precify.PrecifyCoin));

        }

        return '';
    }

    consumoQtde(soma) {

        this.qtdeConsumo = this.qtdeConsumo + (soma ? 1 : -1);

    }

    consumoSend() {

        console.log(this.copycopy.Packages[this.indexes.indexPK].Produtos[this.indexes.indexPD]);

    }

    dismiss() {

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss({}, 'back');
        }

        if (!this.viewCtrl.isOverlay) {
            //this.subscribeProdutoSpot(true);
            this.navCtrl.pop();
        }

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/produto-view/produto-view.ts